import React from "react";
// import blackShoe from "../../../assets/icons/blackshoe.svg";
// import shoeIcon from "../../../assets/icons/shoe.svg";
// import SoccerBall from "../../../assets/icons/soccerr.svg";
import { useTranslation } from 'react-i18next';
import * as moment from 'moment';
import bettingService from "../../../api/services/bettingService";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { BiFootball } from 'react-icons/bi';
import { GiRunningShoe } from 'react-icons/gi';

const SelectedMatchesCard = ({ match }) => {
    const { t } = useTranslation();
    const language = localStorage.getItem("language");
    const [data, setData] = useState(null);
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setData(null);
        const fetchData = async () => {
            try {
                setIsLoading(true);
                const response = await bettingService.bettingHistoryDetails({
                    gamblingId: Number(match.gamblingId),
                    status: "Inplay",
                });
                const res = await response.json();
                if (res && res.length > 0) {
                    setData({ ...match, ...res[0] });
                }
            } catch (err) {
                if (err?.response?.status === 401) {
                    // Redirect to the login page
                    navigate("/login");
                } else {
                    console.error("API request error:", err);
                }
            } finally {
                setIsLoading(false);
            }
        };
        match.gamblingTypeId === 1 && fetchData();
    }, [match, navigate]);

    return (
        <div className='flex flex-col mx-2 my-4 px-3 py-2 rounded-lg h-max bg-white dark:bg-bg_header_dark border border-gray-400 dark:border-gray-600 dark:text-white font-inter text-xs'>
            <div className='pb-2 border-b border-dashed border-slate-500'>
                <div className="flex justify-between items-center w-full">
                    <div className="flex items-center">
                        {
                            match?.gamblingTypeId === 1 ?
                                <span className="">
                                    <BiFootball size={24} className="" />
                                </span>
                            :
                                <span className="">
                                    <GiRunningShoe size={24} className="" />
                                </span>
                        }
                        <h2 className='text-md font-medium whitespace-nowrap ml-2'>{match?.gamblingTypeId === 1 ? t("body") : t("maungg")}</h2>
                    </div>
                    <div className="w-full flex gap-2 items-center justify-end">
                        <p className="dark:text-league_text text-background">
                            {
                                moment(new Date(match?.createdDate)).format('DD.MM.YYYY h:mm A')
                            }
                        </p>
                        <div className='flex justify-end text-k_selectionBgColor font-bold'>
                            <p>{match?.status === 'Inplay' ? 'Ongoing' : ''}</p>
                        </div>
                    </div>
                </div>
            </div>
            
            <div className="py-2 text-bg_header dark:text-white">
                <div className='flex justify-between mb-1'>
                    <h4 className="">BetID</h4>
                    <p className="text-bg-header">{match?.postingNo}</p>
                </div>
                { match?.gamblingTypeId === 2 && (
                    <>
                        <div className='flex justify-between mb-1'>
                            <h4 className={`${language === 'en' ? '' : ''}`}>{t("betAmount")}</h4>
                            <p className="">{parseInt(match?.amount).toLocaleString()}</p>
                        </div>
                        <div className='flex justify-between'>
                            <h4 className={`${language === 'en' ? '' : ''}`}>{t("teamCount")}</h4>
                            <p className="">{match?.teamCount}</p>
                        </div>
                    </>
                )}
            </div>
            <div>
                {isLoading && <div className="border-t-4 border-l-2 border-primary ml-7 rounded-full animate-spin w-5 h-5" />}
                {
                    data?.gamblingTypeId === 1 ?
                        <div className="bg-slate-200 -mx-3 px-2 py-2 dark:bg-gray-700">
                            <div className="flex justify-start pb-2 ">
                                <p className="text-gray-600 dark:text-gray-300">
                                    {data?.eventDate && data.eventDate}
                                </p>
                            </div>
                            <div className="">
                                <div className="flex items-center">
                                    <div className={`grid grid-cols-[3fr_auto_3fr] w-full bg-slate-100 dark:bg-gray-800 py-2 px-3 rounded-full ${language === 'en' ? '' : ''}`}>
                                        <div className={data?.isHomeBodyOdd ? "text-lose text-[0.87rem]" : "text-[0.87rem]"}>
                                            {data.isHome ? language === 'en' ? data?.bettedTeam : data?.bettedTeamMyan : ""}
                                            {!data.isHome ? language === 'en' ? data?.oppositeTeamName : data?.oppositeTeamNameMyan : ""}
                                            {data?.isHomeBodyOdd && (data.home || data.away) && (
                                                <span className="text-xs bg-lose rounded-md px-1 mx-1 py-0.5 text-white">
                                                    {data?.isHomeBodyOdd && data?.bodyOdd}
                                                </span>
                                            )}
                                        </div>
                                        <div className="text-center flex justify-center items-center space-x-2 flex-nowrap bg-slate-200 dark:bg-primary text-primary dark:text-white px-2 rounded-md">
                                            {/* <p className=" text-primary dark:text-white text-xs font-bold">{data?.homeResult}</p>
                                            <BiFootball className="text-lg" />
                                            <p className=" text-primary dark:text-white text-xs font-bold">{data?.awayResult}</p> */}
                                            <p className=" text-primary dark:text-white text-xs font-bold">{data?.homeResult === "NS" ? "VS" : data?.homeResult} {data?.awayResult === "NS" ? "" : `- ${data?.awayResult}`}</p>
                                        </div>
                                        <div className={!data?.isHomeBodyOdd ? "text-lose text-[0.87rem] text-right" : "text-[0.87rem] text-right"}>
                                            {!data?.isHomeBodyOdd && (data.home || data.away) && (
                                                <span className="text-xs bg-lose rounded-md px-1 mx-1 py-0.5 text-white">
                                                    {!data?.isHomeBodyOdd && data?.bodyOdd}
                                                </span>
                                            )}
                                            {!data.isHome ? language === 'en' ? data?.bettedTeam : data?.bettedTeamMyan : ""}
                                            {data.isHome ? language === 'en' ? data?.oppositeTeamName : data?.oppositeTeamNameMyan : ""}
                                        </div>
                                    </div>
                                    {/* <div className="flex-grow text-right">
                                        {data?.isHomeBodyOdd ? <p className="text-lose font-bold">« {(data?.home || data?.away) ? data?.bodyOdd : data?.goalOdd}</p> : <br></br>}
                                        {!data?.isHomeBodyOdd && <p className="text-lose font-bold">« {(data?.home || data?.away) ? data?.bodyOdd : data?.goalOdd}</p>}
                                    </div> */}
                                </div>
                            </div>

                            <div className='flex justify-between items-center text-[0.87rem] font-semibold pt-1'>
                                <h4 className={`text-bg_header dark:text-white ${language === 'en' ? '' : ''}`}>{t('choice')}</h4>
                                
                                <div className="flex justify-end items-center gap-2 pt-2">
                                    <div className="">
                                        {data.overs ? <span className="rounded-md bg-blue-500 px-2 py-1 text-white font-semibold">{data.goalOdd}</span> : ''}
                                        {data.under ? <span className="rounded-md bg-blue-500 px-2 py-1 text-white font-semibold">{data.goalOdd}</span> : ''}
                                    </div>
                                    <div className={`${language === 'en' ? '' : ''} text-center rounded-md bg-blue-500 px-2 py-1 text-white`}>
                                    
                                        {data.home || data.away ? language === 'en' ? data?.bettedTeam : data?.bettedTeamMyan : ''}
                                        {data.overs ? t("goalOver") : ''}
                                        {data.under ? t("goalUnder") : ''}
                                    
                                    </div>
                                    <div className="rounded-md bg-blue-500 px-2 py-1 text-white font-semibold">{parseInt(match?.amount).toLocaleString()}</div>
                                </div>
                            </div>
                        </div>
                        : null
                }
            </div>
        </div>
    );
}

export default SelectedMatchesCard;
